export default {
  'wysiwyg.common.components.PopupContainer':
    '56f27a3a-19bf-4c70-8841-7701269228a0',
};
